export default __webpack_public_path__ + "static/media/InputValidateIcon.378df4af.svg";